import React from "react";
import { useTranslation } from "react-i18next";
import { useEditTask, useMoveKanbanTask } from "@planzone/view-models";

import { Modal } from "@common/modal";
import { Button } from "@common/button";
import { Props } from "./types";
import { Form } from "./form";
import styles from "./styles.scss";

function MoveKanbanTask({
  cancel,
  task,
  currentColumn,
  nextColumn,
  range,
}: Props) {
  const { t } = useTranslation();
  const now = new Date();
  const [completionDate, setCompletionDate] = React.useState(
    new Date(
      Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()),
    ).toISOString(),
  );
  const { isRequestPending, moveKanbanTask } = useMoveKanbanTask();

  return (
    <Modal
      header={t("taskCompletion.title")}
      headerClassName={styles.header}
      close={cancel}
    >
      <div className={styles.main}>
        <h3 className={styles.title}>{t("taskCompletion.subTitle")}</h3>
        <div className={styles.form}>
          <Form
            date={completionDate}
            taskEndDate={task.endDate}
            editDate={setCompletionDate}
          />
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("taskCompletion.cancel")}
          </Button>
          <Button
            className={styles.confirmButton}
            status={isRequestPending ? "pending" : "none"}
            isDisabled={isRequestPending}
            press={() =>
              moveKanbanTask({
                currentColumn,
                nextColumn,
                range,
                task: { ...task, completionDate },
              })
            }
          >
            {t("taskCompletion.submit")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { MoveKanbanTask };
